import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import service from '@/views/service'
import about from '@/views/about.vue'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default new Router({
	scrollBehavior(to,from,saveTop){
	
	if(saveTop){
	
	return saveTop;
	
	}else{
	
	return {x:0,y:0}
	
	} },
  mode: 'history',
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index
    },
	{
		path: '/about',
		name: 'about',
		component: about,
		meta:{
			title:'关于我们'
		}
	},
	{
		path: '/service',
		name: 'service',
		component: service,
		meta:{
			title:'用户协议'
		}
	}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js